import { Injectable, inject } from '@angular/core';
import {LorenBaseCrudService} from '../../../../shared/services/loren-base-crud-service/loren-base-crud.service';
import {LorenGeofencingEndpointsService} from '../loren-geofencing-endpoints-service/loren-geofencing-endpoints.service';
import {LorenGeofencingPolygon} from '../../interfaces/loren-geofencing-polygon.interface';

@Injectable({
  providedIn: 'root'
})
export class LorenGeofencingPolygonService extends LorenBaseCrudService<LorenGeofencingPolygon> {

    protected endpointsService: LorenGeofencingEndpointsService;


    constructor() {
        const endpointsService = inject(LorenGeofencingEndpointsService);

        super(endpointsService.geoFenceZonesPolygons());
        this.endpointsService = endpointsService;
    }
}
